export default "__VITE_ASSET__7498df0b__"